import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

interface Props {
    title: string;
    value?: string | number;
    percent?: number;
    icon?: ReactNode;
    onClick?: () => void;
}

export default function SmallCount({
    title,
    value,
    percent,
    icon,
    onClick,
}: Props) {
    return (
        <Card onClick={onClick}>
            <CardContent>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Box
                        sx={theme => ({
                            height: '5rem',
                            width: '5rem',
                            borderRadius: '5rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: theme.palette.background.paper,
                            marginRight: theme.spacing(2),
                        })}
                    >
                        {icon}
                        {percent && (
                            <Typography variant="body1">{percent}%</Typography>
                        )}
                    </Box>
                    <Box>
                        <Typography variant="subtitle1">{title}</Typography>
                        <Typography variant="subtitle2">{value}</Typography>
                    </Box>
                    <Box></Box>
                </Box>
            </CardContent>
        </Card>
    );
}
